/**
 * Global brand theme — Les Entrepreneurs (entrepreneurs branch).
 * Use these tokens everywhere. Do not hardcode brand colors in components.
 */

export const brand = {
  id: "entrepreneurs",
  name: "Les Entrepreneurs",
  logoUrl:
    "https://lesentrepreneurs.ma/wp-content/uploads/2025/08/Entrepreneurs-maroc-logo.svg.svg",
  /** Compact mark — mini drawer + favicon */
  iconUrl: "/icon.svg",

  colors: {
    accent: "#F50145",
    accentHover: "#D0013A",
    accentSoft: "rgba(245, 1, 69, 0.1)",
    accentRing: "rgba(245, 1, 69, 0.18)",
    accentBorder: "rgba(245, 1, 69, 0.35)",
    ink: "#111827",
    muted: "#6B7280",
    line: "rgba(17, 24, 39, 0.08)",
    surface: "#FFFFFF",
    surfaceSoft: "rgba(255, 255, 255, 0.9)",
    bg: "#F7F7F8",
    bgElevated: "#FFFFFF",
    critical: "#C2410C",
    criticalSoft: "rgba(194, 65, 12, 0.12)",
    onAccent: "#FFFFFF",
  },

  fonts: {
    display: '"Source Serif 4", Georgia, "Times New Roman", serif',
    body: '"Source Sans 3", "Public Sans", sans-serif',
  },

  radius: {
    sm: "0",
    md: "0",
    lg: "0",
    xl: "0",
    pill: "0",
  },

  /** CSS filters for sidebar SVG icons (tint to brand colors) */
  iconFilters: {
    muted:
      "brightness(0) saturate(100%) invert(45%) sepia(8%) saturate(520%) hue-rotate(169deg) brightness(94%) contrast(88%)",
    accent:
      "brightness(0) saturate(100%) invert(14%) sepia(100%) saturate(7428%) hue-rotate(342deg) brightness(100%) contrast(80%)",
    ink: "brightness(0) saturate(100%) invert(7%) sepia(14%) saturate(900%) hue-rotate(169deg) brightness(95%) contrast(95%)",
    onAccent: "brightness(0) saturate(100%) invert(100%)",
  },
};

export default brand;
